import RichUpdatesItem from './RichUpdatesItem';

export default RichUpdatesItem;



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesItem/index.tsx